export default "__VITE_ASSET__CFHF40qw__"